import script from "./ModalCollateralTVL.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalCollateralTVL.vue?vue&type=script&setup=true&lang=js"

import "./ModalCollateralTVL.vue?vue&type=style&index=0&id=4e26e32f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e26e32f"]])

export default __exports__